// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1hld5","inputWrap":"Table_inputWrap__2KUCy","col":"Table_col__3L1iS","bmiTooltip":"Table_bmiTooltip__17qkt"};